<template>
  <div id="client-access-list">
    <b-overlay
      variant="white"
      :show="tableLoading"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <b-card>
        <b-tabs v-model="activeTab" @input="onTabChange">
          <b-tab title="Dados de Acessos de Clientes">
            <custom-g-table v-if="displayTable" ref="custom-table" :displayLoading="tableLoading" :fields="fields"
              :items="data" :totalRows="totalRows" :limit="limit" :hasDeleteButton="false" :hasUpdateDataButton="true"
              :hasAdvancedFilterButton="true" :hasExportDataButton="true" :hasPerPageSelect="true"
              :advancedFilters="advancedFilters" @changePage="onChangePage" @onSortChange="onSortChange"
              @onColumnFilter="onFilter" @updateData="updateData" @exportData="exportData" @fetchAdvancedFilter="onFilter"
              @limitChanged="onLimitChanged" />
          </b-tab>
          <b-tab title="Dados Estatísticos dos Acessos" lazy>
            <b-row class="access-statistics-filters">
              <b-col md="3">
                <b-form-group>
                  <label>{{ "Perído" }}</label>
                  <flat-pickr v-model="dtRangeAccessStatisticsFilters" placeholder="Perído" :config="{
                    enableTime: false,
                    dateFormat: 'Y-m-d',
                    altInput: true,
                    altFormat: 'd/m/Y',
                    allowInput: true,
                    mode: 'range',
                  }" />
                </b-form-group>
              </b-col>
              <b-col md="9">
                <b-button class="btn-sm btn-nav-link btn-nav-link-white" size="sm" variant="flat-primary"
                  @click="fetchDataDay">
                  <feather-icon icon="SearchIcon" />
                  1 Dia
                </b-button>
                <b-button class="btn-sm btn-nav-link btn-nav-link-white" size="sm" variant="flat-primary"
                  @click="fetchDataWeek">
                  <feather-icon icon="SearchIcon" />
                  1 Semana
                </b-button>
                <b-button class="btn-sm btn-nav-link btn-nav-link-white" size="sm" variant="flat-primary"
                  @click="fetchDataMonth">
                  <feather-icon icon="SearchIcon" />
                  1 Mês
                </b-button>
              </b-col>
              <b-col md="12">
                <b-button class="btn-sm btn-nav-link btn-nav-link-white" size="sm" variant="flat-primary"
                  @click="loadStatisticsData">
                  <feather-icon icon="SearchIcon" />
                  Pesquisar
                </b-button>
                <b-button class="btn-sm btn-nav-link btn-nav-link-white btn-filter-clear" size="sm" variant="flat-primary"
                  @click="clearAccessStatisticsFilters">
                  <feather-icon icon="TrashIcon" />
                  Limpar
                </b-button>
              </b-col>
            </b-row>
            <b-overlay class="custom-overlay" :show="displayOverlay" rounded="sm">
              <div style="margin-top: 40px;">
                <h5>Percentual de dispositivos utilizados nos acessos:</h5>
                <ul>
                  <template v-if="device && device.length > 0">
                    <li v-for="(item, index) in device" :key="index">
                      <p>{{ `${item.device_name}: ${item.device_value.toFixed(2)}%` }}</p>
                    </li>
                  </template>
                  <li v-else>
                    <p>Nenhum registro encontrado</p>
                  </li>
                </ul>
    
                <br><br>
    
                <h5>Percentual de browsers utilizados nos acessos:</h5>
                <ul>
                  <template v-if="browser && browser.length > 0">
                    <li v-for="(item, index) in browser" :key="index">
                      <p>{{ `${item.browser_name}: ${item.browser_value.toFixed(2)}%` }}</p>
                    </li>
                  </template>
                  <li v-else>
                    <p>Nenhum registro encontrado</p>
                  </li>
                </ul>
    
                <br><br>
    
                <h5>Percentual de sistemas operacionais utilizados nos acessos:</h5>
                <ul>
                  <template v-if="operatingSystem && operatingSystem.length > 0">
                    <li v-for="(item, index) in operatingSystem" :key="index">
                      <p>{{ `${item.os_name}: ${item.os_value.toFixed(2)}%` }}</p>
                    </li>
                  </template>
                  <li v-else>
                    <p>Nenhum registro encontrado</p>
                  </li>
                </ul>
    
                <br><br>
    
                <h5>Percentual de países acessando a plataforma:</h5>
                <ul>
                  <template v-if="countryAccess && countryAccess.length > 0">
                    <li v-for="(item, index) in countryAccess" :key="index">
                      <p>{{ `${item.country_name}: ${item.country_value.toFixed(2)}%` }}</p>
                    </li>
                  </template>
                  <li v-else>
                    <p>Nenhum registro encontrado</p>
                  </li>
                </ul>
              </div>
            </b-overlay>

          </b-tab>
        </b-tabs>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import { BCard, BTab, BTabs, BButton, BCol, BRow, BFormGroup, BOverlay } from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import dropdownService from "@/providers/dropdownService";
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import clientService from "@/providers/clientService";
import AppConstants from "@/appConstants";
import formatFieldHelper from '@/helpers/format-field-helper';
import flatPickr from "vue-flatpickr-component";
import messagesNotifyHelper from "@/helpers/messages-notify-helper";
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  props: {
    urlQuery: Object
  },
  components: {
    BCard,
    BTab,
    BTabs,
    BButton,
    BCol,
    BRow,
    BFormGroup,
    BOverlay,
    CustomGTable,
    flatPickr
  },
  data() {
    return {
      displayTable: false,
      sortField: {},
      data: [],
      totalRows: 0,
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      page: 1,
      filter: {},
      tableLoading: true,
      syncParamsForm: {
        origin: null
      },
      isSyncing: false,
      activeTab: 0,
      dataLoaded: false,
      fields: [
        { field: "email", label: "Cliente", sortable: true },
        // { field: "client", label: "Perfil", type: "object", object_field: "system_prop", object_in_object_field: "profile", sortable: true },
        { field: "profile", label: "Perfil", sortable: true },
        { field: "time", label: "Tempo de acesso (minutos)", sortable: true },
        { field: "dt_create", label: "Data primeiro acesso", type: "custom_date", sortable: true },
        { field: "dt_update", label: "Data último acesso", type: "custom_date", sortable: true },
        { field: "isDesktop", label: "Dispositivo", type: "boolean", sortable: true },
        { field: "origin", label: "Origem", type: "object", object_field: "name", sortable: false },
        { field: "publisherOrigin", label: "Origem do publisher", sortable: false },
        { field: "geolocation", label: "Localização (Região)", type: "object", object_field: "region_name", sortable: false },
        { field: "geolocation", label: "Localização (Cidade)", type: "object", object_field: "city_name", sortable: false },
        { field: "ip", label: "IP", sortable: false },
        { field: "userAgent", label: "User Agent", sortable: false },
        { field: "_id", label: "ID", sortable: false },
      ],
      advancedFilters: [
        { field: "email", label: "Email", type: 'input', value: '', size: 4 },
        { field: "origin", label: "Origem", type: 'dropdown', value: '', size: 3, multiple: false, filterDropdownItems: [] },
        { field: "dt_create", label: "Data primeiro acesso", type: 'dateRange', value: '', size: 2 },
        { field: "device", label: "Dispositivo", type: 'dropdown', value: '', size: 2, multiple: false, filterDropdownItems: [
          { name: 'Desktop', value: 'true' },
          { name: 'Mobile', value: 'false' }
        ] },
        // { field: "acess_time", label: "Tempo de acesso", type: 'dropdown', value: '', size: 2, multiple: false, filterDropdownItems: [] },
      ],
      filters: {},
      origins: [],
      device: [],
      browser: [],
      operatingSystem: [],
      countryAccess: [],
      dtRangeAccessStatisticsFilters: "",
      displayOverlay: false
    };
  },
  mounted() {
    this.$store.dispatch("admin/updatePageTitle", "Acesso de clientes");
    this.loadDataFilter();
    // this.transformFilterDropdownItems();
    // this.loadStatisticsData();
  },
  computed: {
    searchParams() {
      const params = buildParamsRouteQuery(this.$route.query);
      params.append("page", this.page);
      params.append("limit", this.limit);

      if (this.sortField.field) {
        params.append(`sort_${this.sortField.field}`, this.sortField.type);
      }

      // if (this.filters.client) {
      //   params.append('client', this.filters.client);
      // }
      // if (this.filters.dt_create) {
      //   params.append('dt_create', this.filters.dt_create);
      // }
      // if (this.filters.origin) {
      //   params.append('origin', this.filters.origin);
      // }

      return params;
    },
  },
  methods: {
    onTabChange() {
    if (this.activeTab === 1 && !this.dataLoaded) {
      this.loadStatisticsData();
      this.dataLoaded = true; 
    }
  },
    onLimitChanged(newLimit) {
      this.limit = newLimit;
      this.loadData();
    },
    exportData() {
      if (!this.searchParams.has("dt_create") || !this.searchParams.get("dt_create")) {
        messagesNotifyHelper.errorNotify("Acessos de clientes", "Filtro data é obrigatório.");
        return;
      }
      this.tableLoading = true;
      clientService
        .reportClientAccessSystem(this.searchParams)
        .then((response) => {
          this.tableLoading = false;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", 'acessos_clientes.xlsx');
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((err) => {
          this.tableLoading = false;
          console.log(err);
        });
    },
    setInitialTableFilters() {
      // Object.keys(this.urlQuery).forEach(item => {
      //   this.fields[this.fields.findIndex(val => val.field==item)].filterOptions.filterValue = this.urlQuery[item];
      // });
      Object.keys(this.urlQuery).forEach(item => {
        this.advancedFilters[this.advancedFilters.findIndex(val => val.field == item)].value = this.urlQuery[item];
      });
      this.loadData();
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onFilter(data) {
      console.log('onFilter', data);

      let filteredData = { ...data };

      if (data.device !== undefined) {
        filteredData.isDesktop = data.device;
        delete filteredData.device;
      }

      setRouteQuery(filteredData, this.$route.query);
      this.filters = filteredData;
      this.loadData();
    },
    loadDataFilter() {
      const params = new URLSearchParams();
      params.append('code', AppConstants.ORIGINS.SAFRAS_PLATFORM);
      dropdownService.getAllOrigin(params)
        .then(res => {
          // const origins = res.map(item => {
          //   return { value: item.id, text: item.name };
          // });
          // this.fields[this.fields.findIndex(item => item.field=='origin')].filterOptions.filterDropdownItems = origins;
          this.advancedFilters[this.advancedFilters.findIndex(item => item.field == 'origin')].filterDropdownItems = res;
          this.syncParamsForm.origin = res.find(item => item.code == 250);
          this.setInitialTableFilters();
        })
        .catch(err => console.log(err));
    },
    loadData() {
      this.data = [];
      this.tableLoading = true;
      // this.displayTable = false;
      onlyLatestRequest(this, 'loadData', clientService.getAllClientAccessSystem(this.searchParams))
        .then((res) => {
          this.displayTable = true;
          this.data = res.data.map(item => {
            if (Number(item.time) > 60) {
              item.time = formatFieldHelper.convertSecondsToMinutes(item.time)
            } else {
              item.time = `${item.time} segundos`
            }
            return item;
          });
          this.totalRows = res.totalRows;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.displayTable = true;
          console.log(err);
        });
    },
    onSortChange(params) {
      this.sortField = params;
      this.loadData();
    },
    clearFilters() {
      this.fields.forEach(field => {
        if (field.filterOptions && field.filterOptions.filterValue !== undefined) {
          field.filterOptions.filterValue = '';
        }
      });
      const query = { ...this.$route.query };
      Object.keys(query).forEach(key => {
        if (!['page', 'limit', 'lang'].includes(key)) {
          delete query[key];
        }
      });
      this.$router.replace({ query });
      this.$forceUpdate();
    },
    updateData() {
      // this.clearFilters();
      this.loadData();
    },
    loadStatisticsData() {
      this.displayOverlay = true;
      const params = this.buildParams();
      Promise.all([
        clientService.getDeviceClientAccessSystem(params),
        clientService.getBrowserClientAccessSystem(params),
        clientService.getOperatingSystemClientAccessSystem(params),
        clientService.getCountryClientAccessSystem(params)
      ])
        .then((res) => {
          this.device = res[0];
          this.browser = res[1];
          this.operatingSystem = res[2];
          this.countryAccess = res[3];
          this.displayOverlay = false;
        })
        .catch((err) => console.log(err));
    },

    clearAccessStatisticsFilters() {
      this.dtRangeAccessStatisticsFilters = ""
    },

    formatDateButtom(date) {
      return date.toISOString().split('T')[0]; // Formato YYYY-MM-DD
    },

    getCurrentDate() {
      const today = new Date();
      return this.formatDateButtom(today);
    },

    getLastWeekRange() {
      const end = new Date();
      const start = new Date(end);
      start.setDate(start.getDate() - 7);
      return `${this.formatDateButtom(start)} até ${this.formatDateButtom(end)}`;
    },

    getLastMonthRange() {
      const end = new Date();
      const start = new Date(end);
      start.setDate(start.getDate() - 30);
      return `${this.formatDateButtom(start)} até ${this.formatDateButtom(end)}`;
    },

    fetchDataDay() {
      this.clearAccessStatisticsFilters();
      this.dtRangeAccessStatisticsFilters = this.getCurrentDate();
      this.loadStatisticsData();
    },

    fetchDataWeek() {
      this.clearAccessStatisticsFilters();
      this.dtRangeAccessStatisticsFilters = this.getLastWeekRange()
      this.loadStatisticsData();
    },

    fetchDataMonth() {
      this.clearAccessStatisticsFilters();
      this.dtRangeAccessStatisticsFilters = this.getLastMonthRange()
      this.loadStatisticsData();
    },

    buildParams() {
      const params = new URLSearchParams();
      if (this.dtRangeAccessStatisticsFilters) {
        params.append("dt_range", this.dtRangeAccessStatisticsFilters);
      }
      return params;
    }
  }
};
</script>